import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

function Landing() {
  const navigate = useNavigate()
  const [state, Setval] = useState(null)
  
  useEffect(() => {
    const arr = ["Hello", "नमस्ते", "Kon'nichiwa", "Hola", "Bonjour", "Salaam", "Szia", "Ciao", "Hallo"]
    let val = 0
    
    const interval = setInterval(() => {
      if (val === 8) {
        clearInterval(interval)
        setTimeout(() => navigate("/main"), 400)
      } else {
        Setval(arr[val++])
      }
    }, 400)
    
    return () => clearInterval(interval) // Cleanup to prevent memory leak
  }, [navigate])
  
  return (
    <div className='relative flex justify-center items-center h-screen overflow-hidden'>
      {/* Animated gradient background */}
      <div className='absolute inset-0 bg-gradient-to-br from-purple-900/20 via-black to-cyan-900/20 animate-pulse-slow'></div>
      
      {/* Radial gradient overlay */}
      <div className='absolute inset-0 bg-gradient-radial from-transparent via-black/50 to-black'></div>
      
      {/* Greeting text with animations */}
      <div className='relative z-10 animate-fadeIn'>
        <h1 className='text-6xl md:text-8xl font-bold text-center bg-gradient-to-r from-accent-purple via-accent-cyan to-accent-pink bg-clip-text text-transparent animate-glow'>
          {state}
        </h1>
      </div>
    </div>
  )
}

export default Landing
